module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-layout-sider', {
    staticClass: "navsider",
    model: {
      value: (_vm.collapsed),
      callback: function($$v) {
        _vm.collapsed = $$v
      },
      expression: "collapsed"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [(!_vm.collapsed) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Admin后台管理系统")]) : _vm._e(), _vm._v(" "), (_vm.collapsed) ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "text-align": "center"
    }
  }, [_vm._v("Admin")]) : _vm._e()]), _vm._v(" "), _c('a-menu', {
    staticClass: "navmenu",
    attrs: {
      "theme": "dark",
      "selectedKeys": _vm.current,
      "openKeys": _vm.openKey,
      "mode": "inline"
    },
    on: {
      "openChange": _vm.openChange,
      "click": _vm.handleClick
    }
  }, [_c('a-menu-item', {
    key: "mainpage"
  }, [_c('a-icon', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('span', [_vm._v("首页")])], 1), _vm._v(" "), _c('a-sub-menu', {
    key: "costcenter"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a-icon', {
    attrs: {
      "type": "dollar"
    }
  }), _c('span', [_vm._v("费用中心")])], 1), _vm._v(" "), _c('a-menu-item', {
    key: "accountpandect"
  }, [_vm._v("账户总览")]), _vm._v(" "), _c('a-menu-item', {
    key: "voucher"
  }, [_vm._v("账户充值")])], 1), _vm._v(" "), _c('a-sub-menu', {
    key: "ordermanagement"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a-icon', {
    attrs: {
      "type": "calendar"
    }
  }), _c('span', [_vm._v("订单管理")])], 1), _vm._v(" "), _c('a-menu-item', {
    key: "transactionlist"
  }, [_vm._v("交易列表")]), _vm._v(" "), _c('a-menu-item', {
    key: "transactionreconciliation"
  }, [_vm._v("交易对账")])], 1), _vm._v(" "), _c('a-menu-item', {
    key: "membermanagement"
  }, [_c('a-icon', {
    attrs: {
      "type": "smile"
    }
  }), _vm._v(" "), _c('span', [_vm._v("会员管理")])], 1), _vm._v(" "), _c('a-sub-menu', {
    key: "bdmodule"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a-icon', {
    attrs: {
      "type": "robot"
    }
  }), _c('span', [_vm._v("BD管理")])], 1), _vm._v(" "), _c('a-menu-item', {
    key: "bdmanagement"
  }, [_vm._v("BD管理")]), _vm._v(" "), _c('a-menu-item', {
    key: "bdreconciliation"
  }, [_vm._v("BD交易对账")])], 1), _vm._v(" "), _c('a-sub-menu', {
    key: "agentmanagement"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  }), _c('span', [_vm._v("代理商管理")])], 1), _vm._v(" "), _c('a-menu-item', {
    key: "agentlist"
  }, [_vm._v("代理管理")]), _vm._v(" "), _c('a-menu-item', {
    key: "agentrank"
  }, [_vm._v("代理绩效排名")]), _vm._v(" "), _c('a-menu-item', {
    key: "agentcheck"
  }, [_vm._v("代理商交易对账")])], 1), _vm._v(" "), _c('a-sub-menu', {
    key: "usermanagement"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a-icon', {
    attrs: {
      "type": "team"
    }
  }), _c('span', [_vm._v("用户管理")])], 1), _vm._v(" "), _c('a-menu-item', {
    key: "permissionmanagement"
  }, [_vm._v("权限组管理")]), _vm._v(" "), _c('a-menu-item', {
    key: "newadministrator"
  }, [_vm._v("创建新管理员")]), _vm._v(" "), _c('a-menu-item', {
    key: "administratormanagement"
  }, [_vm._v("管理员管理")])], 1), _vm._v(" "), _c('a-menu-item', {
    key: "salemainpage"
  }, [_c('a-icon', {
    attrs: {
      "type": "bar-chart"
    }
  }), _vm._v(" "), _c('span', [_vm._v("销售报表")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2234c563","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/components/menu_bar.vue
// module id = 2368
// module chunks = 1